import './search-bar.scss';

const SearchBar = ({
    id,
    label,
    value,
    placeholder,
    onChange,
    onClear,
    meta
}) => {
    const hasValue = Boolean(value);

    return (
        <div className="search-bar">
            <label className="search-bar__label" htmlFor={id}>
                {label}
            </label>

            <div className="search-bar__row">
                <div className="search-bar__input-wrap">
                    <input
                        id={id}
                        type="search"
                        className="search-bar__input"
                        placeholder={placeholder}
                        value={value}
                        onChange={(event) => onChange(event.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Escape' && hasValue) {
                                event.preventDefault();
                                onClear();
                            }
                        }}
                    />

                    {hasValue ? (
                        <button
                            type="button"
                            className="search-bar__clear-icon"
                            aria-label="Clear search"
                            onClick={onClear}
                        >
                            ×
                        </button>
                    ) : null}
                </div>

                {hasValue ? (
                    <button
                        type="button"
                        className="search-bar__clear"
                        onClick={onClear}
                    >
                        Clear
                    </button>
                ) : null}
            </div>

            {meta ? (
                <p className="search-bar__meta">{meta}</p>
            ) : null}
        </div>
    );
};

export default SearchBar;
